const template = require('./suggestion.tpl').default;

module.exports = DomClass(template, function() {
	this.changeText = this.delta >= 0 ? `+${this.delta}` : this.delta;
});
